import Vue from "vue";
Vue.directive("title", {
	inserted: function (el) {
		document.title = el.getAttribute("title");
	},
});



// WEBPACK FOOTER //
// ./src/directives/index.js